import { response, client } from 'http-otro';

let apiURL = (process.env.API_URL || '/');
window.parkave_api_url = apiURL;

export { apiURL }
let clientConfig = {
  host: apiURL,
  transforms: [
    (args)=>{
      let token = localStorage.getItem('token');
      let user = localStorage.getItem('user_id');
      let account = localStorage.getItem('account_id');

      if(token){
        args.headers.authorization = token;
        if (user) {
          args.headers['x-user-id-override'] = user;
        }
      }

      if (account) {
        args.headers['x-account-id'] = account;
      }

      return args
    }
  ]
};

let http = client(clientConfig);

export { response }
window.http = http;
export default http;



// WEBPACK FOOTER //
// ./src/lib/api/client.js